import { Auth } from "aws-amplify";

const getUser = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser(); // Await the promise
        return user.username; // Return the username
    } catch (err) {
        console.log("Error in getUser: ", err);
        return null; // Handle the case where user is not authenticated
    }
};

export const createProjectAPI = async (formData) => {
    const username = await getUser();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/create_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in creating project: ${error.message}`);
    }
};
        
export const fetchAllProjectsAPI = async () => {
    const formData = new FormData();
    const username = await getUser();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/fetch_all_projects`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in fetching projects: ${error.message}`);
    }
};

export const deleteProjectAPI = async (formData) => {
    const username = await getUser();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/delete_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in deleting project: ${error.message}`);
    }
};

export const updateProjectTagsAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/tag_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in updating project tags: ${error.message}`);
    }
};


export const getProjectByIdAPI = async (projectId) => {
    if (!projectId) {
        throw new Error("Project ID is required");
    }
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_project_by_id/${projectId}`,
            {
                method: "GET",
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in getting project by id: ${error.message}`);
    }
};

export const importArtifactToProjectAPI = async (formData) => {

    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/import_artifact_to_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in importing artifact to project: ${error.message}`);
    }
};
    

export const getArtifactsForUserAPI = async () => {
    const username = await getUser();
    const formData = new FormData();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_artifacts_for_user`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in getting artifacts for user: ${error.message}`);
    }
};
    

export const deleteArtifactInProjectAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/delete_artifact_in_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in deleting artifact from project: ${error.message}`);
    }
};


export const updateProjectAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/update_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in updating project: ${error.message}`);
    }
};
    
// clone_project
export const cloneProjectAPI = async (formData) => {
    const username = await getUser();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/clone_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in cloning project: ${error.message}`);
    }
};

// invite_to_project
export const inviteUserToProjectAPI = async (formData) => {
    const username = await getUser();
    formData.append("inviter_username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/invite_to_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in inviting user to project: ${error.message}`);
    }
};


export const publishProjectAPI = async (formData) => {
    const username = await getUser();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/submit_project_for_publishing_pipeline`,
            {
                method: "POST",
                body: formData,
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error publishing project: ${error.message}`);
    }
};

export const getProjectPublishingStatusAPI = async (projectId) => {
    if (!projectId) {
        throw new Error("Project ID is required");
    }
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_project_publishing_status/${projectId}`,
            {
                method: "GET",
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error getting project publishing status: ${error.message}`);
    }
};

export const getUserDevValProjectsAPI = async () => {
    const username = await getUser();
    const formData = new FormData();
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/get_user_dev_val_projects`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in getting user dev val projects: ${error.message}`);
    }
};